var NavMazdaConstants = function() {

    this.MATRIX = {
        'sedan': require('./constants/sedan.js'),
        'suv': require('./constants/suv.js'),
        'crossover': require('./constants/crossover.js'),
        'minivan': require('./constants/minivan.js'),
        'hatchback': require('./constants/hatchback.js'),
        'luxury': require('./constants/luxury.js'),
        'convertible': require('./constants/convertible.js'),
        'default': require('./constants/default.js')
    };

    this.MAKE = {
        name: 'Mazda',
        nicename: 'mazda',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885835&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885835&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037108/skeleton.gif'
    };

    this.IMG_HOST = '//static.ed.edmunds-media.com/unversioned';
    this.EVENT_TYPE_FIRE_IMPRESSION_TRACKING = 'fire_impression_tracking';
    this.NAV_ITEMS = ['nav_new_future_makes', 'nav_car_types', 'nav_research'];
    this.NAV_ITEMS_TYPES = ['newFuture', 'carTypes', 'researchMain', 'researchMake'];
    this.SLIDE_TRACKING_NUMBERS = [0, 1, 5];
};

module.exports = new NavMazdaConstants();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav-sponsorship/constants.js
// module id = 2
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14